import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import colorsJsonGreen from '../../../../assets/teiasoft-themes/green.json';
import colorsJsonBlue from '../../../../assets/teiasoft-themes/blue.json';
import colorsJsonSilver from '../../../../assets/teiasoft-themes/silver.json';

@Component({
  selector: 'teiasoft-button',
  templateUrl: './teiasoft-button.component.html',
  styleUrls: ['./teiasoft-button.component.scss']
})
export class TeiasoftButtonComponent {
  @Input() type: string = "tb-primary";
  @Input() text:string = "";
  @Input() disabled: boolean = false;
  @Input() theme?: string = "silver";
  @Input() isMobile: boolean = false;
  @Input() noWidth: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() secondaryActionIcon?: string;

  @Output() onClick: EventEmitter<any> = new EventEmitter();
  @Output() onSecondaryActionClick: EventEmitter<any> = new EventEmitter();

  constructor(){}

  onTbClick(){
    this.onClick.emit('');
  }

  onTbSecondaryActionClick(){
    this.onSecondaryActionClick.emit('');
  }
}
